import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

/**
 * @name mirror-rectangular
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTEgNiA4IDkiIC8+CiAgPHBhdGggZD0ibTE2IDctOCA4IiAvPgogIDxyZWN0IHg9IjQiIHk9IjIiIHdpZHRoPSIxNiIgaGVpZ2h0PSIyMCIgcng9IjIiIC8+Cjwvc3ZnPg==) - https://lucide.dev/icons/mirror-rectangular
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const MirrorRectangular: IconNode = [
  ['path', { d: 'M11 6 8 9' }],
  ['path', { d: 'm16 7-8 8' }],
  ['rect', { x: '4', y: '2', width: '16', height: '20', rx: '2' }],
];

export default MirrorRectangular;
